// apps/web/src/shared/capCount.ts
// ─────────────────────────────────────────────────────────────────────────
// Display cap for review workload counts. Product rule: users should never
// stare at a big scary number of due cards. Anything above the cap renders
// as "10+", while the underlying scheduling math keeps the real number.
// Applies to WORKLOAD counts (ready, new, weak spots). Trophy counts like
// Retained and day streaks stay real; a big number there is the reward.
// ─────────────────────────────────────────────────────────────────────────

export const COUNT_DISPLAY_CAP = 10;

/** Format a workload count for display, capping at "10+". */
export function capCount(n: number): string {
	return n > COUNT_DISPLAY_CAP ? `${COUNT_DISPLAY_CAP}+` : String(n);
}
